<video #videoPlayer id="video" controls preload="metadata">
  <source [src]="src"
          [type]="type">
  <ng-container *ngFor="let track of tracks | keyvalue">
    <track [label]="track.value.label"
           [kind]="track.value.kind"
           [srclang]="track.value.srclang"
           [src]="track.value.src">
  </ng-container>
</video>